import PropTypes from 'prop-types'

import { NotyButtonUI } from './NotyButton.css'

const NotyButton = ({ label, ...props }) => {
  return (
    <NotyButtonUI size="sm" outlined {...props}>
      {label}
    </NotyButtonUI>
  )
}

NotyButton.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.element.isRequired,
  ]),
  status: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  rel: PropTypes.string,
  state: PropTypes.oneOf(['danger']),
  target: PropTypes.string,
}

export default NotyButton
